// extracted by mini-css-extract-plugin
module.exports = {"form":"MenuItemControl_form__2FaaA"};